import React from "react";
import { Stack } from "@bookingcom/bui-react";
import { StopsFilterDesktop } from "./FiltersSplit/StopsFilter";
import { AirlinesFilterDesktop } from "./FiltersSplit/AirlinesFilter";
import { FlightTimesFilterDesktop } from "./FiltersSplit/FlightTimesFilter";
import { DurationFilter } from "./FiltersSplit/DurationFilter";
import { BudgetPerAdultFilter } from "./FiltersSplit/BudgetPerAdultFilter";
import { AllDealsFilter } from "components/elements/SearchFilters/FiltersSplit/AllDealsFilter";
import useProfiler from "../../../hooks/useProfiler";
import { useGetAvailableFilters } from "../SearchResults/components/boundsFilterHooks";

const SearchFiltersDesktop = ({ shouldMoveBudgetFilter }: { shouldMoveBudgetFilter?: boolean }) => {
  const availableFilters = useGetAvailableFilters();
  const { isLoggedIn } = useProfiler();

  return (
    <div>
      {Object.keys(availableFilters).length > 0 ? (
        <Stack gap={8}>
          <StopsFilterDesktop />
          {!shouldMoveBudgetFilter && <BudgetPerAdultFilter />}
          {isLoggedIn() && !!availableFilters.deals && <AllDealsFilter />}
          <AirlinesFilterDesktop />
          <FlightTimesFilterDesktop />
          <DurationFilter />
          {!!shouldMoveBudgetFilter && <BudgetPerAdultFilter />}
        </Stack>
      ) : null}
    </div>
  );
};
export default SearchFiltersDesktop;
